class AssignmentsService {
    getPersistValueFromLocalStorage(userid) {
        let storedStudentPersistData = JSON.parse(localStorage.getItem(
            "StudentPersistentValue"
        ));
        return storedStudentPersistData ? storedStudentPersistData[userid] : null;
    }

    setPersistValueToLocalStorage(userid, studentIds) {
        var storedStudentPersistData = JSON.parse(localStorage.getItem(
            "StudentPersistentValue"
        ));
        if (storedStudentPersistData) {
            if (storedStudentPersistData[userid]) {
                storedStudentPersistData[userid] = [...new Set([...storedStudentPersistData[userid], ...studentIds])];
            } else {
                storedStudentPersistData[userid] = studentIds;
            }
            localStorage.setItem(
                "StudentPersistentValue",
                JSON.stringify(storedStudentPersistData)
            );
        } else {
            let persistValue = {};
            persistValue[userid] = studentIds;
            localStorage.setItem("StudentPersistentValue", JSON.stringify(persistValue));
        }
    }
}

export default AssignmentsService


// WEBPACK FOOTER //
// ./app/components/assignments/assignments.service.js